export { assetDir } from '../Platform/Platform.js'
